export default "__VITE_ASSET__c03be60c__"